import React from 'react';
import Table from 'react-bootstrap/Table';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import Card from 'react-bootstrap/Card';
import {Button} from '@material-ui/core';

import ValContacts from "../base/ValContacts";
import DelNav from './DelNav';
import SPUtilities from "../util/SPUtilities";
import SPCalc from "../util/SPCalc";

import IRewardUtils from "./IRewardUtils";
import IUtils from "./IUtils";

class DelRewardsCalc extends React.Component {
  render() {
    return (
      <div>
        <p><b>Delegate Rewards Calculations</b></p>
        <Table striped bordered size="sm" >
          <thead>
            <tr>
              <th>Category</th>
              <th>Before Fee</th>
              <th>Net</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td align="left">Delegate Block Rewards Per Year</td>
              <td align="left"> {this.props.delegate.blockRewardsPerYear}</td>
              <td align="left"> {this.props.delegate.netBlockRewardsPerYear}</td>
            </tr>
            <tr>
              <td align="left">Delegate Foundation Bonus Per Year</td>
              <td align="left"> {this.props.delegate.foundationBonusPerYear}</td>
              <td align="left"> {this.props.delegate.netFoundationBonusPerYear}</td>
            </tr>
            <tr>
              <td align="left">Delegate Epoch Bonus Per Year</td>
              <td align="left"> {this.props.delegate.epochBonusPerYear}</td>
              <td align="left"> {this.props.delegate.netEpochBonusPerYear}</td>
            </tr>
            <tr>
              <td align="left">Delegate Rewards Per Year</td>
              <td align="left"> {this.props.delegate.totalRewardsPerYear}</td>
              <td align="left"> {this.props.delegate.netRewardsPerYear}</td>
            </tr>
            <tr>
              <td align="left"><b>Apr</b></td>
              <td align="left"> {this.props.delegate.apr}</td>
              <td align="left"> {this.props.delegate.netApr}</td>
            </tr>
            <tr>
              <td align="left"><b>Blended Share</b></td>
              <td>&nbsp;</td>
              <td align="left"> {this.props.delegate.blendedShare}</td>
            </tr>
            <tr>
              <td align="left">Reward Percent Per Day</td>
              <td>&nbsp;</td>
              <td align="left"> {this.props.delegate.rewardPercentPerDay}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  }
}
// <tr>
//   <td align="left">Reward Per Day - 10k IOTX</td>
//   <td align="left"> {IRewardUtils.rewardPerDayByAmount(this.props.delegate.rewardPercentPerDay, 10000)}</td>
//   <td align="left"> {IRewardUtils.get91DayDailyReward(this.props.delegate.rewardPercentPerDay, 10000)}</td>
// </tr>
// <tr>
//   <td align="left">Reward Per Day - 100k IOTX</td>
//   <td>&nbsp;</td>
//   <td align="left"> {IRewardUtils.rewardPerDayByAmount(this.props.delegate.rewardPercentPerDay, 100000)}</td>
// </tr>
// <tr>
//   <td align="left">Reward Per Day - 1 million IOTX</td>
//   <td>&nbsp;</td>
//   <td align="left"> {IRewardUtils.rewardPerDayByAmount(this.props.delegate.rewardPercentPerDay, 1000000)}</td>
// </tr>

export default DelRewardsCalc;



// WEBPACK FOOTER //
// ./src/iotex/DelRewardsCalc.js